import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';


const useUploadPDF = (
    options?: UseMutationOptions<Error>
) => {
    return useMutation<any, Error, any>({
        mutationFn: async (body: object): Promise<any> => {
            const URL = `${import.meta.env.VITE_API_PDF_UPLOAD}`;
            // Replace `priceDevelopment` with `price_development`
            const { priceDevelopment, ...rest } = body;
            const transformedBody = {
                ...rest,
                price_development: priceDevelopment,
            };

            const { data } = await axiosClient.post(URL, transformedBody);
            return { data };
        },
        ...options
    });
};

export default useUploadPDF;
